export const isLoggedIn = () => {
  const accessToken = localStorage.getItem('token');
  if (accessToken && accessToken.length) {
    return accessToken
  } else {
    return null
  }
}
